<template>
  <div>
    <TemplateHeader />
    <slot />
    <TemplateFooter />
    <ClientOnly>
      <ChatBaseWidget />
      <template #fallback />
      <QuizModal />
      <LanguageModal />
    </ClientOnly>
  </div>
</template>
<script setup lang="ts">
import LanguageModal from "~/features/translation/components/LanguageModal.vue";
import QuizModal from "~/slices/users/components/modals/QuizModal.vue";
import TemplateFooter from "~/shared/components/layout/TemplateFooter.vue";
import TemplateHeader from "~/shared/components/layout/TemplateHeader.vue";
import { useSiteSettings } from "~/slices/settings/composables/settings";
import { useUnread } from "~/slices/users/composables/api";
const ChatBaseWidget = defineAsyncComponent(
  () => import("~/features/chatbase/ChatBaseWidget.vue"),
);

// Call composables in setup() so vue-query has injection context; defer the actual fetch until after first paint (LCP).
const queryAfterPaint = ref(false);
provide("queryAfterPaint", queryAfterPaint);
useSiteSettings(); // uses injected queryAfterPaint
const { runAfterPaint: runUnreadAfterPaint } = useUnread();

onMounted(() => {
  const runAfterPaint = () => {
    queryAfterPaint.value = true;
    runUnreadAfterPaint?.();
  };
  if (typeof requestIdleCallback !== "undefined") {
    requestIdleCallback(runAfterPaint, { timeout: 500 });
  } else {
    setTimeout(runAfterPaint, 0);
  }
});
</script>
